import { styled } from '@mui/system'

export const Row = styled('div')`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 0;
`

export const MetaItem = styled('div')`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`
